"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1({ isPreview }) {
    const uid = (0, react_redux_1.useSelector)((state) => state.roomData.uid);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ fullWidth: true, component: "a", href: `/@${uid}`, onClick: e => isPreview && e.preventDefault(), sx: {
            height: '40px',
            p: 0,
            borderRadius: '8px',
            border: '1px solid var(--gray-10)',
            lineHeight: 1,
            color: 'var(--gray-80)',
            bgcolor: 'var(--white) !important',
        } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2" }, { children: t('마켓') })) })));
}
exports.default = default_1;
